var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticStyle: { display: "inline-block" } }, [
    _c(
      "div",
      { staticClass: "spaceLeft auth-status", class: "status" + _vm.status },
      [
        +_vm.status == 2
          ? _c("img", {
              attrs: { src: require("@/assets/image/auth/passed.png") },
            })
          : +_vm.status == 3
          ? _c("img", {
              attrs: { src: require("@/assets/image/auth/notpassed.png") },
            })
          : +_vm.status == 1
          ? _c("img", {
              attrs: { src: require("@/assets/image/auth/ing.png") },
            })
          : _c("img", {
              attrs: { src: require("@/assets/image/auth/passed.png") },
            }),
        _vm._v(" "),
        _c("span", [
          _vm._v(
            _vm._s(
              _vm._f("dictFilter")(
                _vm.status,
                _vm.$store.getters.producerAuthSatatus
              )
            )
          ),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }